export const NsTopDomain = 'nspgroup.com';
export const NsConnect = `//nsconnect.${NsTopDomain}`;
